import { FeeServiceApi, FeeService } from '../models';

export function mapFeeServiceApiToFeeService(feeServiceApi: FeeServiceApi): FeeService {
  return {
    id: feeServiceApi.id,
    name: feeServiceApi.name,
    fee: Number(feeServiceApi.fee),
    min: feeServiceApi.min,
    serviceType: feeServiceApi.serviceType,
    vehicleType: feeServiceApi.vehicleType,
    commercialBusiness: feeServiceApi.commercialBusiness,
    validFrom: new Date(feeServiceApi.validFrom).toISOString(),
    validTo: new Date(feeServiceApi.validTo).toISOString(),
  };
}
